import { render, staticRenderFns } from "./detail-receipt.vue?vue&type=template&id=74653e98&scoped=true"
import script from "./detail-receipt.vue?vue&type=script&lang=js"
export * from "./detail-receipt.vue?vue&type=script&lang=js"
import style0 from "./detail-receipt.vue?vue&type=style&index=0&id=74653e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74653e98",
  null
  
)

export default component.exports